import { useEffect, useRef } from 'react'
import styles from './AmbientBackdrop.module.css'

interface Props {
  enabled: boolean
  videoRef: React.RefObject<HTMLVideoElement | null>
  playing: boolean
}

export function AmbientBackdrop({ enabled, videoRef, playing }: Props) {
  const canvasRef = useRef<HTMLCanvasElement>(null)

  useEffect(() => {
    if (!enabled) return
    let raf = 0
    let last = 0
    const tick = (ts: number) => {
      raf = requestAnimationFrame(tick)
      if (!playing || ts - last < 120) return
      last = ts
      const video = videoRef.current
      const canvas = canvasRef.current
      if (!video || !canvas || video.readyState < 2) return
      const ctx = canvas.getContext('2d')
      if (!ctx) return
      canvas.width = 64
      canvas.height = 36
      try {
        ctx.drawImage(video, 0, 0, 64, 36)
      } catch {
        /* cors tainted */
      }
    }
    raf = requestAnimationFrame(tick)
    return () => cancelAnimationFrame(raf)
  }, [enabled, playing, videoRef])

  if (!enabled) return null
  return <canvas ref={canvasRef} className={styles.ambient} aria-hidden />
}
